<template>
  <div id="invoice-page">
    <div id="printMe2">
      <vx-card id="invoice-container">
        <table style="width: 100%" class="border-collapse">
          <tr>
            <td>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAFnxJREFUeJztXWtwVEd21kozGkmMMjMaSegxYD0sJI3eeCSBhN5YEgVoDYIYy4Zg7Fpsg0NZjrUxjp3gFSjYZZHwqjK4Qtm7bKiYLRaXCPtgIaK8ECd2suUV6z/sFvOUEBaPxeDCa4f01zNXe3XnPmfujGS4X1UXj7m3+9w+3afPOX36dEyMBg0aNGjQoEGDBg0aNGjQoCGquHXmTMblxx/rdJlN29x5eQc8xcU/8xQWnqcFfy8q+pErLW3QUzRv87V9e4u+Hh2NiyZ9tz/80DK+5fk2l9n8sttme5vQdMxjtw9T+kpKTpE/j7gzMna70q191/bsLvnqD3+IKn0zErfODpvcRYW97tzcj5xxMXdp0ZMSL1J0/udcVovbnZvz7vhTTzZFir6vLl40eMpKN2CATdKnk0ef02S8CqaPdnZ03f3Tn74TKRpnJC5veDLdW1W50ZVqPe1MMnwpyVS+ovcXlyn5ksdevMNX81DerdOnDWrQ9/lrr5q8tTWr3XPnvO9MTrzOtBUKfU5j0qg7K+uQz+EonxgcVIW+GQswgIjah11p1o+chrivQ2KsUGeiI3Nz9lxescIWKn0Qq76G+joy8E46E3R3VKUvKeGqKz3138a6Vxap2aczBr7mpizMNKdBd1uVThMQj67UlE88lRVtStfoKy/9jcVbXvaC06CfUI2xfIyelej05OdvuPH++wmR6uuowze/qpCM4It01kaKuexCmIROlCuyId7dc2zDdNZGhT7dbW9lxatYCiLd9xEHFBVnouF8xGaF0ExJiPf6GhufkEMjWWtfo4pRtOhDIWs7oe/1SPd/RPF/t27FOuN1ZxUxF8/GCRQpDZanHu/8+X8pRuPevXuzv7l6NdZpTDzn1Md+EzX6AnWNtrW+EC1+qAqqiTocg7KZiw4iighsTMy8Px45UvzlJx9n3Pn007QvTgzlURuU2JhEkRpSpACRZWGsp6eUj8aOjo7VZrP5ytq1a4v9TDYOCDKZoY+YZt4ax4Yb771bytB3+9e/ziYaci0sA6p5wzKQy2xSr2dewfJo8ydswCkhS+zB1CFa9djKlR1y18yJHf25cIbA1pTDaJfFfIGrdA0PD5tgn+bm5v54CpMTEvqn0K33vw+z6eZPjxnl0Hdt/74UogO8DltdHn2mcTKg00Lp52nB2PLl86AtSn4c6UjMCCg5StsYf/aZ1NHWlmVUeZPRDqQCM4B6enpS8/Pz3161atXiqqoqW2pq6sc5OTkfdnZ2LvBVVqY6DYYhOgP1lL4hb0V5lVL6rg7sSBxtb2+AVi/HeePOz/87vKO0najjy4//Ww97VPKjjEmX3dlZr+H5cNojdmsO1YCl2xv1OeY34p2uri6r0Wg8mZCQcIXF5P9KT0//3SSTk5L+FVIoXHMGAxGDWJI+onRBSoTTVlTga2srA/PE10VixpB1B0qYGm3CM+bOyjwvqiRB1KZaT0709yfjndbWVqvJZNrJMLm2tjYzOzv7IJi8bNmyKmj/dy5ciFeDPgwST37eYVEfgJ++01f375+lRpsRA9Ye0dFKPhI2KtY7Ndsd7WjPd5n/4t9F2ybKmae8fC3zjsvl0rGZDNENJre0tGxWkzYAjhS4LCX7prKiTe22VQPWOGrzioxSZ/KsTyJl4PvXZKLBis2SjNmnvhgamlzrwOT4+PhzFotlpLu7uxlMRokEfb6GRRXQxMXo8zoe6o9E26rAU1xc6ZyVcFP4A2K/8VZUdEeqffiS3basw6KzBGYJaxYDDJMxk0tKSsoiRR+ALUVR+sgEuHXqVFIkaQgZvrqFTwoSH5i9Nw7/KDmiNDgc5USKjIsrNMbPoPyw3xsbG9PZ7fbVe/bsiSh9dBKIzWJi+mGmR5KGkCE6e2Cq1Ne/HBU68vIGRGeJnjoXBqJBCxeQMqLePYjpCEq5kAFHAiVcRDxHy2MzumTJfJhFUrN4bEnngmjQw4WnrPQtMQaPNjc9Px10iQIhNxDBQh3qzsn5LRwg0aAFs4Rq82KeNJ3fLJmO0BrMUNEZ7HAMRpsmScB37EqxjAh1KGKYrh08kBktesY6OmzuObbjoqJa5/dwRYsmBi5jYovg4IOmT8y9aNMkCTjfXVbLZ4IMLiw8cvODDyJifghh/HtPF4hq9fGI7Ur5vW/x4pd8ra3fV1rG1jzad3NoyKyULspgIacMYfCluJgzkeiPsCBnBt94772MaNNFd3fE1mKx7T+xQuxtspYeCIUmZ5K+RXC3CQyOjf0PlbshfGDLTGwNRngpZlS06Zp4Y6dN9c18IhW8dQv/KlSavHb7SrE1ONSBE1FIatEIdbVYHp4O2mgsmFoRJWEyF4C5KMZgiH+1vl1VEDPooJgdTDpm23TQdWdkJEnu3mykmYvdM9EQJmjRZIar9e2qwreofpMY4TBLpiuakJpN4UR0EuZ6Cuf9E1GswvJ0YVNE1EbHIAph/zkq8NiLFol24jTulmAbDnHJIc3iwMwNl7kANvbFwnmIifS/1w/9i2LNPCoAYWKKFrMnO77lr2WFvqiNgIdLfK86AmKZAYLeaaSLSP9ASqjRVsQgNUKxJ4sA8+nwIE16uOQGxKnJ3MfWzHZZzOKOF0g4IgXVaC9i8FY7HKK7JSi6OLevttY+HfTJ2m1imKuiy5BGmEo4XSD9ELCnVpsRAcwlycgFvZ/JamiLiAxBDBhZY+fKfUdytwmFDAK1Ypa9CxfslBMYiJOMarQXcciaJUxgOjGdQgnfQcjrld4XCuiar6fHST9D6K2cdxHDhd0kyVmMqEpb1mFi2oSkM/zxJz9JpQfZpJgbWHtnfDwWG+683D7ZcdEW80VEWcjRHhGoN77u8YdcWZnHguonS4NcJvtaWrppXLUc+ogNjaD2a7t3Z8up+/OX/7ZAUdy2NeX3sNXl1D1jgGOcssJFmdmM45Up5rO+2prn3dmZjePPPVd4/dCh2QgIR8dibcd+MkY6nX1w1vPUjSD68XVrJV2iMHnomSQ5CpfevyaDPkJHL0MfdsdAH+iEhoyjsdRrBqki9/QFpBgZPNHgiepAcB09C6z0bBLpHMwaiF1sYNBdKnoQm5+pfEwWOq7CBj2vjHBWpfQZ4r7m0ofTCYrPPCPgPSNjt9oRplEFAtNlnT5QswSiJ+UoXhiE9LxTNOlDISYRJJxaWQmmFTj8TU8fRPLwN7uYkt1uW3a3XFsbMcuSgemqMlc/4bUXf++eOgT++Stb/WtyJM/hBtZyRGkoTXwCjZeGtCo9AqqUPrKWQwG9J7PwwEaGZ4iaUGqLxDi/WL68akVxqPRhUCArDg6Pq87oOL9ucLlreY2afTojgfNBCFuFeRDWjA7Y0lhDLz+zsUKt3FmwR+FypcpduBIH9JHlaWxVd+uXH/3nt3+9VQLYtDhRh3CeKeEwYsHzgWdw2Ayn/67uGnwwkjSOr1+/lC4tOBKjgD7X7PTf4DD7xPb+mbn1F01c2/WW1Z2e/jD2k2lnxuvOYtts0gQhf6cpFpIST+HsDlyc2FeN1oyAAwa2L05uUAcGQx9oC5hKDH2IeUbaCG9rq13ugfH7Dji6iSx4cCIgUO/WqV+acZQz2ukLhQBaQBNoo84YoqDBE3VPKk4aNGjQoEGDBg0aNGjQoEGDBg0aNGjQoEGDBg0aNGjQoEGDBg0aNGi456BW6n8NCoBgM19N9eP0rl+7fdhly3Yh4Sju0qX36wbu+Q23HQTgKT1pjwHhspgPMJdwKAVCZemdwOxSVrqBGWjjTz21Juh3uaWs9C2mHvQP7kWWKi6LZaevo/1R9Hko36Ps45995gGaDwvHIyWyufqD0nM/Gl3SuTjU9nCGB6f2EMUo9x10INIB4j13dvYSpW2OtrZuDIp9TkjoZxgzunhxb+gnM3RnmXomBnbUyw6sx3O4cyI/7zAOsCv9JnkfvmTJ/MmrVxWdx0l0glG4rkZpmziOQrPC1i18Uu4VPJMMptfNKc8HMiMZPEmH7g6y0co5Ay0bIAgHpnAZczhHOBAYjjS/ctvFOR6mA3BSAFf2yKV3ksGBfCAYnHID5Wc0gwOTBofRVTvnhBPoglfDMjdd42iH2CFtfIjBMOQtKrLKaZNeQ4NMsfo/v48USHIUrikMZmhMiPdCinxx4oTkkc2QGAyphj6QKlIM5ma/Fbp9PJD6Iuw7MJD2njf9D9bYRMM4MuogtYI794FapFnAERSkOcAIo+8xBBuNA0pENBS4KVfk+I+GXpQjAYIYzBTc21te9oJUshMpBiO/dNDvBsNBd0F+nVRxWYzlTDtBDKbSJuZ/nLrvNNOUw6TQ/nQ81M974hEZAmzZ4WUCoslOuB9DRYRlBEwQeu/zl17KRAYd/wfozio5dkJTI/Fd8BEnL1GnIIPjY2QlagmFwZdiYv5B7vcxmBjYvojLYKFk4DjzTJnM+R4kWlfa7iTGNz1XxydC3DkP/EKuJocRqPRMkeDVM4HUDFLKliiDUchSgnPAQu9Hj8HBM1gs2zsS1HDbhWmqtF0KyHb/ST/OhxKNGHk3QqpUJkQvtyRin2jFrWLvSzI4UA8SlPG9P1MZTEU355tcadYxpe1S4Lhk0DVxPLeGqQ2o/6LaeiA5mVhmGlkMDtTFl109agx+Y2edEgbDpue2CweT0nYpqJLD7SBTsjvSV+PgbK2gxv7ndVRU2RJkMJ9UwN0LRfM2s7XzUBgM/wBSHwoVvptMlTAY7/NlrocjKbSOnlSQWJ2TaDgf7n2/YqA5nVOtp4OYwtXioT0WFfYK1cPLYJ0/oxxvJh1i4sDO9y2opbdwh6RF60UKoQPXwXPplMtgHJCHuxLZeYKlme3tkDobomtK43GRv+4FmeKCGECYi5vAuCYCbtZGykC+engZjKv1CGO8lRWv8jIZ9jux08HkkBgsVuQyGIUwEdKAKXAOMfk4+eoN+fY29/yqfdwZEEkGIyFYUEZ2jNC8vAO4DpZq1ezf4JcVSJ4txGA4KHCNuiCTMYjA5MbG4DuQo8VgfYAOtgTgqxN+9jm24yHvtAWJaFp0ZyOVpgAbEljjg0boqm6qMUMUcZmPdIJ8ypYggwPpga+/c9AkmEczzl/vtDEYCUyl8koHnD6+lpa6kDuc5rPiquREu8VuUsiViiAonWAgRTDz+8QPflDpspgvcDuOT6sXm8HMM5AY1Hkg1xcspUUT6XaJaNKX9PrXaYmN3cYufCmJ+RiMekTvGNb58215i4rCU3bheqQJNjkjB66+sCrmwcSO/tygjk5OvM5NkE1FK1d7nZ3+G259chg8WSe0djlMjoaZFGDw2IoVmf6MusEz19fcPMinkSsGnPK8IynRMC53V0cuqPjldii9xqbwPHuzHF4bPvclPG7s+pQwGPDk5iwVzX8VZQbjN3pdPV8+azUdTaPt7Q1Bo5tRRJqbsuTUAS1PbMeDKlBC2eH5TA6eZ7jKllIGw5XqMpu2BZkh08hgms+a7+oBou0jC58quhB1+vNd0arz70ciSx1fsi90GBwisFWh/SIKAYoNXxveGseGsPNCktnOrl8pg5lvpTNZ6NKqKDMYoH4BvhtdkXC1oT50BYsNelOX0AyDxynRcB4+XSgsWM9gs1INFfcDsfZjwWRuFAJGIdZQWTNXbCbD8ZGX28ek5w2FwQxwcRf2WZUyGFfmwH6WLi3LJhk8OFgrxmDa/7AuuJ49feD+KbUUXpgqolflyBSlNBM7y8VIiecuAWQwwckCO1ywUI2bc/8umXlMkF04DKYMJLODzpwpdrfEhr+cQan3Xx07ueEvg8EATZ8YtP9M7OC5c95XLeIUNmRYaYADtptn7lyaPJTaony2bVbmMantRcRYBd1ghr1iomXj93AZTNvoaH+U2sNyGSyzgIFKGQyPXZASGHCB4u4IJXwU/+iGRRX0DgYla2aAEDhO2HvI9A5d7uxN0N2R2gpkQO9mCjKtjJ8h8bgaDAZgvlH/tYoMnhKyI5PBtL+qHb18DhAkRVWa/FwUCFyDYkTXTiZuiPsRgZBZKkaQUpd0FLcOuqnAHZFkPYdWLYcOhAdNmWGBOkCbWgwGcLMKzSYbjieL/Y1iDNYL3/5NAx/5zFb42Gtrnlf6XZKA1nnrzJkMiDLEW2GTHmsFiHClW/vgeRK6CwgOfZfZ/DL18sD7EyhKXG8w9rE/yq2D/Hs9fsef4dTPxs0PPkj1VlR0M25R1MP1VNHCeLHYJfi59ZMMfmOnjeeZ9UJ0wAEy2W/MtwXaDeW7ZAPaMFxxKGCqnIUfYkUN0SJWh5qiC5KF7fdm6A+lcGkU+k3om9jPqdWPGjRo0CCAkpKSsnnz5i0vLS3tstlsTQMDA4JXrDY0NKTjOTyPkpKS0r5u3bpcoefZWLNmje3BBx9c6nA41qAdsfc2btyY3NTU1EyeD9q16evrM5E62rm/gTaGLoa21atXq3fE5NsIu92+2mKxXCR/vYuSkJBwu6io6KBQ5+fl5dXiGeZ5lJycnA87OzsXjI2N6YTaQYfPmTPnpF6v/wrv4E+8V11d3cT3fHd3dylp68KsWbNe4/729NNPFxKaPTEc9yQGD5suhjbUJacv7ins2bMHM+TvyV/vZmRk7N+3b9/8o0ePFnd0dKzOzc39OemUZr73Kisrq8nzPjIAHsHzb775ZnVaWtpRMH3BggU9fO+0tbX1Btr52RNPPNF+4sSJfDIgvpuZmfke/p/vvbVr1xYXFBR8mp6e3sf9bdOmTQVCDMZgPXTo0ELQhm8ymUw/NZvNV8i/FR+8+1aDMAodd3fRokXrFL5HGdzY2Djluhp0eGxs7DB3Fr/yyislaKelpWXDuXPngg6fMczfu3fvlKtjw2DwCJeZYHpWVtZWMQlzT+HYsWMWIvo+xkxV+q4QgyFO+RgM6QAxKVYnGEBm2s6RkZHJjXQ1GUx0jCHUf98weOvWrTnoVCJWt7P//5FHHpnV09NjR+cyZcuWLVP2nfkYvHLlymqsqdnZ2Qe5baFzZ8+e/ZYYPYSR76IQ0W1h/i8UBmOdJ+L4t2wGd3V1Wcl3XiHMf/a+YfCLL76Yhw7iMhgKFDqVKWBkfn7+FC8NGJycnHwjPj7+HGYsCjoQ0mDZsmVBt4wRJW4Ys0eMHjLD96vBYMxg0pYPYh9LAv4Ew8l3nHvnnXcs3HruWRw5csQIEQ2lh/3/7Bm8dOnSx61W6zi3g8FgKC3l5eU/rKmpGYRyBUUGShtfW2AeOlho9mBdJm38DgOJLaJ7e3vzMTj4tGhIDz7awGBIEnwbBiBKYWHhP8N8UtI/9wTIbP0+OoNPyWptbbUajcaTmJnckc8V0WBMYmLiDSF7kxHfZWVlW1Av+zeXy6WD+Mb7WDbYv2EQgjkYHPg7+x3QjiVm8+bNU4LOmTX4+PHjmRhQ941I5kNVVZWNzMRfYTbCFmY6g2izGVCM0OkBM2oKuAzGegeRDWYIzWJi/x7FM2SN3sGsj9CaiQR4DsyHJOB7j0gRbF3eJXT0MQyD+Ube8WG95zIQDOauwfc10EFkBuJsDXU8gAn4O2ZHoHODwDC4rq7OwfwfPFN4DzOL7x0448mA+kdIBKYt/IlBVF9f/6IYjZAweJ5NH1nvfwxvFvdZjcECgHJDRGw3FJNt27bVsNdCLjBL4dzgztbt27cvlHoX6y2eg5MEdYg9y8bw8LAJ7xAl7rFdu3YJRlBgOVFSrwYNGjRo0KBBgwYNGjRomBb8P+/Z8976n5FmAAAAAElFTkSuQmCC"
              />
            </td>
            <td style="padding: 10px; text-align: right">
              <p style="font-size: 18px">Tarih: {{ getNow() }}</p>
              <p style="font-size: 18px">Sıra No: {{ evrakNo }}</p>
            </td>
          </tr>
        </table>

        <table style="width: 100%" class="border-collapse">
          <tr>
            <td>
              <h1 style="text-align: center">TALEP ONAY</h1>
              <h6 style="font-size: 18px; text-align: center">{{ ACTNAME }}</h6>
            </td>
          </tr>
          <tr>
            <td>
              <h6 style="text-align: center; font-size: 18px">
                Sipariş Onayı
              </h6>
            </td>
          </tr>
        </table>

        <table
          border="1"
          style="border-top: 1px solid grey; width: 100%"
          class="border-collapse"
        >
          <tr>
            <td>
              <table style="width: 100% !important; text-align: center">
                <tr>
                  <th
                    sort-key="stokkodu"
                    style="
                      text-align: center;
                      border-bottom: 1px solid grey;
                      padding: 3px;
                    "
                  >
                    Stok No
                  </th>

                  <th
                    style="
                      text-align: center;
                      border-bottom: 1px solid grey;
                      padding: 3px;
                    "
                  >
                    Stok Adı
                  </th>
                  <th
                    style="
                      text-align: center;
                      border-bottom: 1px solid grey;
                      padding: 3px;
                    "
                  >
                    Miktar
                  </th>
                  <th
                    style="
                      text-align: center;
                      border-bottom: 1px solid grey;
                      padding: 3px;
                    "
                  >
                    Fiyat
                  </th>

                  <th
                    style="
                      text-align: center;
                      border-bottom: 1px solid grey;
                      padding: 3px;
                    "
                  >
                    TUTAR
                  </th>
                </tr>

                <tr :key="indextr" v-for="(tr, indextr) in itemListele">
                  <td style="padding: 8px">
                    {{ tr.STOCKNO }}
                  </td>

                  <td style="padding: 8px">
                    {{ tr.STOCKNAME }}
                  </td>
                  <td style="padding: 8px">
                    {{ tr.miktar }}
                  </td>
                  <td style="padding: 8px">
                    {{ tr.fiyat }}
                  </td>
                  <td style="padding: 8px">
                    {{ currencyFormatter(tr.fiyat * tr.miktar, "₺") }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px"></td>
                  <td style="padding: 8px"></td>
                  <td style="padding: 8px"></td>
                  <td style="padding: 8px"></td>
                  <td style="font-weight: bold; padding: 8px">Toplam Tutar:</td>
                  <td style="font-weight: bold; padding: 8px">
                    {{ currencyFormatter(toplamTutar, "₺") }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <br />
        </table>

        <br />
        <table style="width: 100%" class="border-collapse">
          <tr>
            <td>
              <h6 style="text-align: center; font-size: 18px">
                Yalnız; {{ yaziyaCevir(toplamTutar) }} tahsil edilmiştir.
              </h6>
            </td>
          </tr>
          <tr>
            <td>
              <h6 style="text-align: center; font-size: 18px">
                Tahsilat Vadesi: {{ tahsilatvadesi }}
              </h6>
            </td>
          </tr>
          <tr>
            <td>
              <h6 style="text-align: center; font-size: 18px">
                Kapatılan borçların vadesi {{ kapatilanBorcunVadesi }} Aradaki
                Fark: {{ vadeFarkGun }} gündür.
                <span v-if="gecVadeValidate == true && gecVadeNedeni != ''"
                  >Nedeni : {{ gecVadeNedeni }}</span
                >
              </h6>
            </td>
          </tr>
          <tr>
            <td>
              <h6 style="text-align: center; font-size: 18px">
                Tahsil Eden: {{ company }}
              </h6>
            </td>
          </tr>
        </table>
      </vx-card>
    </div>
  </div>
</template>
<script>
//import { defineComponent } from "@vue/composition-api";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import userJson from "../../../../../public/user.json";
import moment from "moment";
import { isMobile } from "mobile-device-detect";
export default {
  name: "SiparisDetayButton",
  props: [],
  //[ pazaryerData=[], "orderNumber", "invoiceFirstName", "invoiceLastName", "shipFullName"],
  components: {},
  data() {
    return {
      evrakNo: "",
      loginpng: userJson.invoiceLogo,
      ACTNAME: "",
      logoUrl: "",
      company: "",
      companyAdres: "",
      sipariseGoreUrunListesi: [],
      itemListele: [],
      toplamTutar: 0.0,
      invoiceValidate: true,
      popupKartDetay: false,
      tahsilatvadesi: "",
      vadeFarkGun: "",
      kapatilanBorcunVadesi: ""
    };
  },

  methods: {
    isMobile: function() {
      /*	var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;*/
      return isMobile;
    },
    parseDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },
    currencyFormatter(currency, sign) {
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe2");
    },
    yazdir(items, tahsilatvadesi, kapatilanBorcunVadesi, vadeFarkGun) {
      this.getYazdirList(
        items,
        tahsilatvadesi,
        kapatilanBorcunVadesi,
        vadeFarkGun
      );

      //   setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe2");
    },
    evrakNoGetir(evrakNo) {
      console.log(evrakNo);
      this.evrakNo = evrakNo;
    },
    yaziyaCevir(tutar) {
      var lirast = tutar.toString().replace(".", ","); // Replace('.',',') ondalık ayracının . olma durumu için

      var lirasubstr = lirast.substr(0, lirast.indexOf(",")); //tutarın tam kısmı
      var kurussubstr = lirast.substr(lirast.indexOf(",") + 1, 2);
      var deger = lirast.split(",");
      var lira = deger[0];
      var kurus = deger[1];
      var yazi = "";

      var birler = [
        "",
        "BİR",
        "İKİ",
        "Üç",
        "DÖRT",
        "BEŞ",
        "ALTI",
        "YEDİ",
        "SEKİZ",
        "DOKUZ"
      ];
      var onlar = [
        "",
        "ON",
        "YİRMİ",
        "OTUZ",
        "KIRK",
        "ELLİ",
        "ATMIŞ",
        "YETMİŞ",
        "SEKSEN",
        "DOKSAN"
      ];
      var binler = ["KATRİLYON", "TRİLYON", "MİLYAR", "MİLYON", "BİN", ""]; //KATRİLYON'un önüne ekleme yapılarak artırabilir.

      var grupSayisi = 6; //sayıdaki 3'lü grup sayısı. katrilyon içi 6. (1.234,00 daki grup sayısı 2'dir.)
      //KATRİLYON'un başına ekleyeceğiniz her değer için grup sayısını artırınız.

      lira = lira.padStart(grupSayisi * 3, "0"); //sayının soluna '0' eklenerek sayı 'grup sayısı x 3' basakmaklı yapılıyor.
      var grupDegeri;

      for (
        let i = 0;
        i < grupSayisi * 3;
        i += 3 //sayı 3'erli gruplar halinde ele alınıyor.
      ) {
        grupDegeri = "";
        if (lira.substr(i, 1) != "0") {
          grupDegeri += birler[parseInt(lira.substr(i, 1))] + "YÜZ"; //yüzler
        }

        if (grupDegeri == "BİRYÜZ")
          //biryüz düzeltiliyor.
          grupDegeri = "YÜZ";

        grupDegeri += onlar[parseInt(lira.substr(i + 1, 1))]; //onlar

        grupDegeri += birler[parseInt(lira.substr(i + 2, 1))]; //birler

        if (grupDegeri != "")
          //binler
          grupDegeri += binler[i / 3];

        if (grupDegeri == "BİRBİN")
          //birbin düzeltiliyor.
          grupDegeri = "BİN";

        yazi += grupDegeri;
      }
      if (yazi != "") yazi += " TL ";

      var yaziUzunlugu = yazi.Length;

      if (typeof kurus == "undefined") {
        yazi += "SIFIR Kr.";
      } else {
        if (kurus.substr(0, 1) != "0")
          //kuruş onlar
          yazi += onlar[parseInt(kurus.substr(0, 1))];

        if (kurus.substr(1, 1) != "0")
          //kuruş birler
          yazi += birler[parseInt(kurus.substr(1, 1))];

        yazi += " Kr.";
      }

      return yazi;
    },
    getYazdirList(items, tahsilatvadesi, kapatilanBorcunVadesi, vadeFarkGun) {
      const today = new Date();

      this.ACTNAME = items[0].ACTNAME;
      this.toplamTutar = 0.0;

      this.tahsilatvadesi = tahsilatvadesi;
      this.kapatilanBorcunVadesi = kapatilanBorcunVadesi;
      this.vadeFarkGun = vadeFarkGun;
      this.itemListele = items;
      console.log(this.itemListele);

      this.itemListele.forEach((val, ind) => {
        this.toplamTutar += parseFloat(val.tutar);
      });
    },
    getList(items, tahsilatvadesi, kapatilanBorcunVadesi, vadeFarkGun) {
      this.ACTNAME = Store.state.account.ACTNAME;
      this.getYazdirList(
        items,
        tahsilatvadesi,
        kapatilanBorcunVadesi,
        vadeFarkGun
      );
    },
    getNow: function() {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const year = today.getFullYear();
      const output = day + "." + month + "." + year;

      return output;
    }
  },
  computed: {
    itemList() {
      return this.$store.state.eCommerce.ITEMLIST;
    },
    gecVadeNedeni() {
      return this.$store.state.account.cariTahsilatGecVadeNedeni;
    },
    gecVadeValidate() {
      return this.$store.state.account.cariTahsilatNedenValidate;
    }
  },
  created() {
    this.logoUrl = Store.state.logoUrl;

    this.company = Store.state.firmaAdi;
  },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  }
  // mounted(){this.siparisDetay()}
};
</script>
